<template>
	<div>
		<transition enter-active-class="animated fadeInUp50px faster" leave-active-class="animated fadeOutDown50px faster">
			<div v-if="showOptions">
				<slot></slot>
			</div>
		</transition>
		<float-button :id="id" :option="true" :icon="icon" :color="color" :title="title" :rotate="true" @action="showOptions = !showOptions"/>
	</div>
</template>

<script>
export default {
	props: ['icon', 'color', 'title', 'id'],
	data() {
		return {
			showOptions: false,
		};
	},
}
</script>

<style scoped>
@keyframes fadeInUp50px {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 50px, 0);
    transform: translate3d(0, 50px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp50px {
  -webkit-animation-name: fadeInUp50px;
  animation-name: fadeInUp50px;
}

@keyframes fadeOutDown50px {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 50px, 0);
    transform: translate3d(0, 50px, 0);
  }
}

.fadeOutDown50px {
  -webkit-animation-name: fadeOutDown50px;
  animation-name: fadeOutDown50px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/OptionsButton.vue